export default "__VITE_ASSET__W3ZD7G9I__"